import localeDe from '@angular/common/locales/de'
import { AppComponent } from './app/app.component'
import { bootstrapApplication } from '@angular/platform-browser'
import { registerLocaleData } from '@angular/common'
import { setInjector } from './app/_shared/decorators/re-init'
import { createCustomElement } from '@angular/elements'
import { InlineFilePreviewComponent } from './app/_shared/components/files/inline-file-preview/inline-file-preview.component'
import { initializeGlobalQ } from '@awork/_shared/functions/global-variables'
import appConfig from './app/app.config'
import { resolveProductConfiguration } from '@awork/_shared/services/product/product-configuration'

const productConfiguration = resolveProductConfiguration(window.location.hostname)

registerLocaleData(localeDe, 'de')

// Initialize the global 'q' variable before bootstrapping the application
initializeGlobalQ()

bootstrapApplication(AppComponent, appConfig(productConfiguration))
  .then(applicationRef => {
    // Set the Injector used by the ReInit decorator
    setInjector(applicationRef.injector)

    // Convert `InlineFilePreviewComponent` to a custom element.
    const FilePreviewElement = createCustomElement(InlineFilePreviewComponent, { injector: applicationRef.injector })

    // Register the custom element with the browser.
    customElements.define('aw-file-preview-element', FilePreviewElement)
  })
  .catch(error => console.error(error))
